module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-cem-elaborazioni",
      "title": "Lista Elaborazioni"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d229d3d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/CemElaborazioni.vue
// module id = 821
// module chunks = 39